// Opening Balance Mutations

export const fetchOpeningBalanceInfo = (state, payload) => {
  state.openingBalanceInfo = payload
}
